define('appkit/service',[
  'underscore',
  'backbone',
  'marionette',

  './radio.mixin',
  './inject.mixin'
], function(
  _,
  Backbone,
  Mn,

  RadioMixin,
  InjectMixin
) {

  function Service(app) {
    this.app = app;
    this.channel = this.app.channel;
    // we want initialize to come before injection
    this.initialize.apply(this, arguments);
    this._initInject(this.inject);
    this._initRadio(this.channel, this.events, _.extend({}, this.replies, this.reply));
  };

  Service.extend = Backbone.Model.extend;

  _.extend(Service.prototype, RadioMixin, InjectMixin, Backbone.Events, {

    // specify which global singletons you would like to
    // inject
    inject: [],

    events: {},

    replies: {},

    initialize: function(app) {

    },

    service: function(name) {
      return this.app.service(name);
    },

    model: function(name) {
      return this.app.model(name);
    },

    request: function() {
      return this.channel.request.apply(this.channel, arguments);
    },

    triggerMethod: Mn.triggerMethod

  });

  return Service;
})
;
